module.exports = __webpack_public_path__ + "img/grocery-store--icon--gray.0aa78037.svg";